import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider, detectLang } from './i18n';

// /en 접두사가 붙어 있으면 영문 모드로 뜨고, basename이 접두사를 떼어 준다.
// 덕분에 App.js의 라우트와 각 컴포넌트의 <Link to="/map"> 은 그대로 둔 채
// 현재 언어의 경로가 유지된다.
const { lang, basename } = detectLang(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <I18nProvider lang={lang}>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </I18nProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
